import { useTranslation } from 'react-i18next';
import classes from './JourneyCanvasIngressEventItem.module.scss';
import { JourneyCanvasIngressEventItemProps } from './TypeDefs';

const JourneyCanvasIngressEventItem: React.FC<JourneyCanvasIngressEventItemProps> = ({ eventName, eventVersion, onClick = undefined, className = '', style = undefined, selected = false, readOnly = false }: JourneyCanvasIngressEventItemProps) => {
  const { t: translate } = useTranslation();
  return (
    <div
      className={`${classes.item} ${className}`}
      style={style}
      data-testid="journeyCanvasIngressEventItem"
    >
      <p className={classes.title} data-testid="ingressName">{eventName} <button data-testid="selectIngress" type="button" onClick={onClick} disabled={selected || readOnly}>{selected ? translate('journey_builder_component.btn_added') : translate('journey_builder_component.btn_add')}</button></p>
      <p className={classes.version} data-testid="ingressDesc">{translate('journey_builder_component.txt_version', { version: eventVersion })}</p>
    </div>
  );
};

export default JourneyCanvasIngressEventItem;
